export class ChangePasswordData {
  currentPassword: string;
  password: string;
}
